<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-sheet color="backgroundGrayColor" height="auto" style="border: solid rgb(220, 220, 220);">
      <v-container class="mx-auto" style="max-width: 1100px; text-align: center">
        <p class="text-left pt-6">社用携帯の電話番号や所持者一覧はこちらから確認して下さい。</p>
        <p class="text-left pb-12">社用携帯に関するお知らせは
          <router-link :to="{ name: 'cellPhone' }" target="_blank">こちら</router-link>
          から確認して下さい。
        </p>
        <iframe width="80%" height="4500px"
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSE231wbzS-84OiLf5Gn83dCqLa_qkZYtGB3YltjnfcDZMC8eZ7kshHBgQk7hZOF6c43zjhGUlEf9_B/pubhtml?gid=0&amp;single=true&amp;widget=true&amp;headers=false"></iframe>
      </v-container>
    </v-sheet>
  </v-main>
</template>

<script>
import Title from '../components/Title';

export default {
  name: 'CellPhoneListView',
  components: {
    Title,
  },
  data() {
    return {
      title: '社用携帯電話番号一覧',
      img: 'title_cellPhoneList.svg',
    };
  },
  computed: {},
};
</script>

<style scoped>
</style>